import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';

import { CustomEventService } from '@shared/services/custom-event.service';
import { WidgetService } from '@shared/services/widget.service';

import { DeveloperListModalComponent } from '@shared/components/modals/developer-list-modal/developer-list-modal.component';

import ActionTypesEnum from '@shared/enums/action-constant.enum';
import { WidgetStatePlaceholderEnum } from '@shared/enums/widget-state-placeholder.enum';

import { avatarCreator } from '@shared/utils/object-mapper.util';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

@UntilDestroy()
@Component({
  selector: 'app-status-progress-widget',
  templateUrl: './status-progress-widget.component.html'
})
export class StatusProgressWidgetComponent implements OnInit {

  @Input() dateFilterable: boolean;
  widgetId: string;
  widgetName: string;
  widgetType: string;
  widgetFooter: Widget.FooterModel;
  headerAddon: string;
  headerComponents: [] = [];
  selectedDate: string;
  note: string;
  url: string;
  from: number;
  showDownloadIcon: boolean;

  @Input()
  set period(period: string) {
    if (period === 'FROM') {
      this.selectedDate = this.from.toString(10);
    } else if (period === 'TODAY') {
      this.selectedDate = `${period}`;
    } else if (period) {
      this.selectedDate = `FROM_LAST_${period}`;
    }
  };

  loading: boolean;
  initialLoading: boolean;
  widgetStatePlaceholderEnum = WidgetStatePlaceholderEnum;
  showWidgetStatePlaceholder: WidgetStatePlaceholderEnum;

  situations: any[];
  work: any;
  time: any;
  assignees: any[];
  assigneesListModal: NzModalRef;

  @ViewChild('toolTipTitle') toolTipTitle: TemplateRef<any>;
  toolTipHTML: string;

  constructor(
    private customEventService: CustomEventService,
    private widgetService: WidgetService,
    private modalService: NzModalService,
  ) { }

  ngOnInit(): void {
    this.toolTipHTML = this.headerComponents.join('<br>');
    this.loadWidgetData(true);

    this.customEventService.eventAnnounced$.pipe(
      untilDestroyed(this)
    ).subscribe(({ action, data }) => {
      if (action === ActionTypesEnum.UPDATE_WIDGET_DATA) {
        this.loadWidgetData();
      }

      if (action === ActionTypesEnum.UPDATE_WIDGET_DATE) {
        const { id, date } = data;

        if (this.widgetId === id ) {
          this.selectedDate = date;
          this.loadWidgetData();
        }
      }
    });
  }

  loadWidgetData(initial?: boolean): void {
    this.loading = true;

    if (initial) {
      this.initialLoading = true;
    }

    this.widgetService.get(this.widgetId, this.selectedDate)
      .pipe(untilDestroyed(this), take(1))
      .subscribe(response => {
        this.loading = false;
        this.initialLoading = false;

        if (!response.data) {
          this.showWidgetStatePlaceholder = this.widgetStatePlaceholderEnum.DATA_NOT_FOUND;
          return;
        }
        this.showWidgetStatePlaceholder = undefined;

        if (response.footer) {
          this.widgetFooter = response.footer;
        }

        this.situations = response.data.situations.map((situation, i, arr) => {
          situation.calculatedClass = `count--1-of-${arr.length}`;

          return situation;
        });
        this.work = response.data.work;
        this.time = response.data.time;
        this.assignees = response.data.assignees.map(avatarCreator).map(item => {
          return {
            ...item,
            fullName: item.displayName
          }
        });
      }, error => {
        console.log('error while fetching widget data', error);
        this.loading = false;
        this.initialLoading = false;
        this.showWidgetStatePlaceholder = this.widgetStatePlaceholderEnum.DATA_NOT_FOUND;
      });
  }

  showAssigneesListModal(): void {
    this.assigneesListModal = this.modalService.create({ 
      nzMaskClosable: false,
      nzContent: DeveloperListModalComponent,
      nzComponentParams: {
        developers: this.assignees,
        type: 'assignees',
        title: 'Assignees in Sprint'
      },
      nzWidth: '450px',
      nzFooter: null
    });
  }

  assigneesUrl(url: string) {
    if (url) {
      window.open(url, '_blank')
    }
  }
}
